import styled, { css } from 'styled-components';
import { BsChevronDoubleRight } from 'react-icons/bs';
import { RiArrowRightSLine } from 'react-icons/ri';
import { FaPlusCircle } from 'react-icons/fa';

import visualImg from 'assets/images/event/250713/visual.jpg';
import visualImgKo from 'assets/images/event/250713/ko/visual.jpg';

import packageImg1 from 'assets/images/event/250713/pakage1.png';
import packageImg2 from 'assets/images/event/250713/pakage2.png';
import packagePlus from 'assets/images/event/250713/plus.png';
import packageArrow from 'assets/images/event/250713/arrow.png';

import curriculumImg from 'assets/images/event/250713/curriculum.jpg';
import curriculumImgKo from 'assets/images/event/250713/ko/curriculum.jpg';

const StyledEventPage = {
  icoArrow: styled.span.attrs(({ children }) => ({
    children: (
      <>
        {children}
        <BsChevronDoubleRight />
      </>
    ),
  }))``,

  icoArrow2: styled.span.attrs(({ children }) => ({
    children: (
      <>
        {children}
        <RiArrowRightSLine />
      </>
    ),
  }))``,

  icoPlus: styled.span.attrs(({ children }) => ({
    children: (
      <>
        <FaPlusCircle />
        {children}
      </>
    ),
  }))`
    svg {
      margin-bottom: -0.14em;
      margin-right: 0.1em;
      font-size: 1.05em;
    }
  `,

  Title: styled.div`
    margin-bottom: 1.8em;
    font-weight: 200;
    font-size: 1.3em;
    color: ${({ color }) => color && color};
    h2 {
      margin-top: 0.3em;
      font-weight: 700;
      font-size: 1.4em;
      color: ${({ colorH2 }) => colorH2 && colorH2};
    }
    @media (max-width: 750px) {
      //font-size: 1.5em;
    }
  `,
  TabCont: styled.section`
    position: relative;
    padding: 2.5em;
    border-radius: 1em;
    background-color: #fff;
    box-shadow: 0 -0.4em 0.8em rgba(0, 0, 0, 0.2);
    @media (max-width: calc(960px + 2em)) {
        padding: 1.5em;
    }
  `,
  EventWrap: styled.div`
    font-family: 'Pretendard';
		font-size: 2rem;
    line-height: 1.2;
    font-weight: 400;
    text-align: center;
    color: #555;
    letter-spacing: -0.035em;

		.blind {
			overflow: hidden;
			position: absolute;
			clip: rect(0 0 0 0);
			width: 1px;
			height: 1px;
			margin: -1px;
		}

    .inner {
      position: relative;
			max-width: 960px;
      margin: auto;
      background-position: 50% 0;
      background-repeat: no-repeat;
      background-size: 100%;
      padding: 6em 0;
    }

    .visual {
      position: relative;
      height: 1010px;
      background-size: cover;
      background-image: url(${visualImg});
      background-repeat: no-repeat;
      background-position: 50% 0;
      background-color: #12162d;
      .dday {
        position: absolute;
        top: 0;
        left: 50%;
        height: 2.5em;
        display: flex;
        align-items: center;
        transform: translateX(-50%);
        background-color: #3bf2ff;
        font-size: 1.4em;
        font-weight: 700;
        color: #0250fa;
        padding: 0.35em 1em;
        margin-top: 6.5em;
        white-space: nowrap;
        strong {
          margin-left: .2em;
          vertical-align: middle;
          font-size: 1.6em;
          font-weight: 900;
          color: #0f43a2;
          span {
            display: inline-block;
          }
        }
        &::before {
          content: '';
          display: block;
          position: absolute;
          left: 0.5em;
          top: 0;
          transform: translateX(-100%);
          border-top: 1.25em solid #3bf2ff;
          border-bottom: 1.25em solid #3bf2ff;
          border-left: 1em solid transparent;
          border-right: 0.5em solid #3bf2ff;
        }
        &::after {
          content: '';
          display: block;
          position: absolute;
          right: 0.5em;
          top: 0;
          transform: translateX(100%);
          border-top: 1.25em solid #3bf2ff;
          border-bottom: 1.25em solid #3bf2ff;
          border-right: 1em solid transparent;
          border-left: 0.5em solid #3bf2ff;
        }
      }
    }
    &.ko .visual {
      background-image: url(${visualImgKo});
    }
    @media (max-width: calc(960px + 2em)) {
      .inner {
          padding-top: 4em;
          padding-bottom: 4em;
          padding-left: 1em;
          padding-right: 1em;
      }
      .visual {
        height: 105.2083vw;
        background-size: auto 105.2083vw;
        .dday {
          margin-top: 22%;
        }
      }
    }
    @media (max-width: 750px) {
      .visual {
        .dday {
          margin-top: 18%;
          font-size: 1.2em;
          height: 2em;
          strong {
            font-size: 1.3em;
          }
          &::before,
          &::after {
            border-top-width: 1em;
            border-bottom-width: 1em;
          }
        }
      }
    }
    .package {
      background: #12162d;
      .package-wrap {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding-top: 3.5em;
        margin-top: -.8em;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: calc(50% - 4.1em);
          width: 8.2em;
          padding-top: 15.625%;
          background-image: url(${packageArrow});
          background-size: cover;
          background-position: bottom center;
        }
        .card {
          width: calc(50% - 3.55em);
          .tit {
            color: #fff;
            font-size: 1.6em;
            font-weight: 600;
          }
          .img {
            position: relative;
            padding-top: 90.465%;
            margin: 0.5em 0 0.8em;
            background-color: rgba(0,0,0,.3);
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 1em;
            &.img1 {
              background-image: url(${packageImg1});
            }
            &.img2 {
              background-image: url(${packageImg2});
            }
            &::after {
                content:'';
                position: absolute;
                top: calc(50% - 1.75em);
                left: calc(100% + 1.775em);
                width: 3.5em;
                height: 3.5em;
                background: #593bf3 no-repeat url(${packagePlus}) center center/contain;
                border-radius: 100%;
                box-shadow: rgba(89,59,243,.9) 0 0 1.25em;
            }
          }
          &:last-child .img::after {
              display: none;
          }
          .desc {
            color: #91cffe;
            font-size: 1.25em;
            font-weight: 300;
          }
        }
      }
      @media (max-width: 750px) {
        .package-wrap {
          flex-direction: column;
          gap: 6em;
          padding-top: 6.5em;
          &::before {
              left: 0;
              width: 100%;
              padding-top: 5em;
              background-size: auto 5em;
              background-repeat: no-repeat;
          }
          .card {
            position: relative;
            width: 100%;
            .img {
              position: static;
              &::after {
                width: 3em;
                height: 3em;
                top: calc(100% + 1.5em);
                left: calc(50% - 1.5em);
              }
            }
          }
        }
      }
    }
    .curriculum {
      background: #eaedf2;
        .tab-tit {
          position: relative;
          display: inline-block;
          font-size: 1.5em;
          color: #3d1d8a;
          margin-bottom: 1.1em;
          h3 {
            position: relative;
            font-weight: 600;
          }
          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0.1em;
            width: 100%;
            height: 0.4em;
            background-color: #cdf297;
          }
        }
      .tab-cont {
        margin: 0 auto;
        max-width: 860px;
        padding-top: 727px;
        background-position: 50% 0;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-image: url(${curriculumImg});
      }
    }
    &.ko .curriculum{
      .tab-cont {
        background-image: url(${curriculumImgKo});
      }
    }
    @media (max-width: calc(960px + 2em)) {
      .curriculum {
        .tab-cont {
          padding-top: 84.543%;
        }
      }
    }

    .report {
      background: #fed440;
      .flow_screen {position: relative; margin: 0 auto; overflow: hidden;}
      .flow_banner {position: relative; display: flex; -webkit-box-align: center; align-items: center;}
      .flow_banner ul {display: flex;}
      .flow_banner li {position:relative; flex-shrink: 0; box-sizing: content-box; width: 300px; height: 385px; border-radius:1em; overflow: hidden; box-shadow: 0.3em 0 0.8em rgba(0,0,0,.12); margin-top:1em; margin-bottom:1em; margin-right: 30px;}
      .flow_banner li img {width: 100%; height: auto;}
      .flow_banner ul:first-of-type {animation: 20s linear 0s infinite normal none running firstFlow;}
      .flow_banner ul:last-of-type {animation: 20s linear 0s infinite normal none running secondFlow; transform: translate(100%);}
      @keyframes firstFlow {
        0% {
            transform: translateX(0);
        }
        50% {
            transform: translateX(-100%);
        }
        50.01%{
            transform: translateX(100%);
        }
        100%{
            transform: translateX(0);
        }
      }
      @keyframes secondFlow {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-200%);
        }
      }
    }
    @media (max-width: 960px) {
      .report{
        .inner {
          padding-left: 0;
          padding-right: 0;
        }
        .flow_banner li {
          width: 31.25vw;
          height: 40.104vw;
          margin-right: 3.125vw;
        }
      }
    }

    .plan {
      background: #0d205b;
      .plan-wrap {
        display: flex;
        justify-content: space-between;
        .card {
          position: relative;
          width: 100%;
          padding: 2em 2em calc(2em + 4.25em) 2em;
          background: #fff;
          border-radius: 1.25em;
          overflow: hidden;
          .btn {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 4.25em;
            line-height: 2.45em;
            padding: 0.8em 2em 1em;
            border-top: 3px solid #0d205b;
            overflow: hidden;
            &.green {
              background-color: #b8ed6b;
              .apply {
                color: #005a14;
              }
            }
            &.blue {
              background-color: #4cf2ff;
              .apply {
                color: #0250fa;
              }
            }
              .in {
                max-width: 52%;
                margin: 0 auto;
              .price {
                float: left;
                font-weight: 600;
                font-size: 1.4em;
                color: #222;
                span {
                  font-size: 1.6em;
                }
              }
              .apply {
                float: right;
                font-weight: 600;
                font-size: 1.4em;
                * {vertical-align: middle;}
              }
              }
          }
          .tit {
            position: relative;
            display: inline-block;
            font-size: 1.5em;
            color: #0f43a2;
            margin-bottom: 1.1em;
            h3 {
              position: relative;
              font-weight: 600;
            }
            &::before {
              content: '';
              position: absolute;
              left: 0;
              bottom: 0.1em;
              width: 100%;
              height: 0.4em;
            }
            &.green::before {
              background-color: #cdf297;
            }
            &.blue::before {
              background-color: #81f6ff;
            }
          }
          .cnt {
            max-width: 52%;
            margin: 0 auto;
            dl {
              margin-bottom: 1em;
              display: flex;
              justify-content: left;
              text-align: left;
              dt {
                position: relative;
                width: 30%;
                padding-left: 0.6em;
                margin-right: 0.6em;
                font-weight: 600;
                color: #0d205b;
                &::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 0.2em;
                  width: 0.2em;
                  height: 0.8em;
                  background-color: #613ee3;
                }
              }
              dd {
                color: #222;
                .add {
                  color: #c2102a;
                }
              }
            }
          }
        }
      }
    }
    @media (max-width: 750px) {
      .plan {
        .plan-wrap {
          display: block;
          .card {
            width: 100%;
            .cnt{
              max-width: 100%;
              dt {
                br {display: none;}
              } 
            }
            .btn {
              .in {
                max-width: 100%;
              }
            }
          }
        }
      }
    }

    .notification {
      background-color: #020f39;
      text-align: left;
      color: #015583;
      font-weight: 300;
      letter-spacing: normal;
      .inner {
        padding-top: 3em;
        padding-bottom: 3em;
      }
      h3 {
        font-weight: 700;
        font-size: 1.3em;
        color: #5e9ec1;
      }
      ul {
        margin-top: 1em;
        font-size: 0.9em;
      }
      li {
        position:relative;
        padding-left: 1.2em;
        margin-bottom: 0.5em;
        color: #015583;
        &:before {
          content:"-";
          display:inline-block;
          position: absolute;
          top:0;
          left:0.3em;
          width: 0.25em;
          height: 0.25em;
          border-radius: 0.2em;
          vertical-align:middle;
        }
      }
    }
  `,
};

export default StyledEventPage;
